import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class VendorApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.VENDOR);
  }

  updateVendor(vendorId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${vendorId}/update/`,
      data,
    );
  }

  requestApproveVendor(vendorId) {
    return this.httpClient.post(
      `${this.getResourceUrl()}${vendorId}/request-approve/`,
      {},
    );
  }

  getProductsOfVendor(vendorId, params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}${vendorId}/products/?${queryString}`
      : `${this.getResourceUrl()}${vendorId}/products/`;

    return this.httpClient.get(url);
  }

  updateVendorProducts(data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}products/multi-update/`,
      data,
    );
  }

  deleteVendorProducts(data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}products/multi-remove/`,
      data,
    );
  }

  exportVendorProducts(vendorId, params = new URLSearchParams()) {
    const exportParams = new URLSearchParams(params);
    exportParams.set('vendor', vendorId);

    const queryString = exportParams.toString();
    const url = `${this.getResourceUrl()}products/export/?${queryString}`;

    return this.httpClient.get(url);
  }
}

export default new VendorApi();
